type Processor<TItem> = (input: TItem) => TItem;

export const processingReducer: <TResult>(
  processors: Array<Processor<TResult>>
) => Processor<TResult> = (processors) => (input) =>
  processors.reduce(
    (updatedInput, processor) => processor(updatedInput),
    input
  );
